export class TransferredCaseFieldValueEntity {
  public fieldLabel!: string;
  public fieldType!: string;
  public valueJson!: string | null;
  public sortOrder!: number;
}
